<script setup lang="ts">
withDefaults(
  defineProps<{
    label?: string
    disabled?: boolean
  }>(),
  {
    label: '',
    disabled: false,
  },
)

const checked = defineModel<boolean>({ default: false })
</script>

<template lang="pug">
label.ui-switch.flex.row-8(:class="{ disabled, checked }")
  input.ui-switch-checkbox(
    type="checkbox"
    :checked="checked"
    :disabled="disabled"
    @change="checked = !checked"
  )
  .toggle-switch.br-16
  span.switch-label {{ $t(label) }}
</template>

<style scoped>
.ui-switch-checkbox {
  position: absolute;
  visibility: hidden;
}

.ui-switch {
  --uno: typ-14-20-400;
  align-items: center;
  color: var(--cue-content-neutral-secondary);
  cursor: pointer;

  .toggle-switch {
    position: relative;
    background: var(--cue-bg-surface-primary);
    width: 42px;
    height: 24px;
    transition: 0.4s;
    border: 1.5px solid var(--cue-border-neutral-tertiary);
    flex-shrink: 0;
  }

  .toggle-switch:before {
    content: '';
    --uno: d-block s-16 position-absolute t-3 l-3 br-50p;
    background-color: var(--cue-bg-primary-default);
    transition: 0.4s;
  }

  &:hover:not(.disabled) .toggle-switch:before {
    background-color: var(--cue-bg-primary-default-hover);
  }

  &.checked {
    .toggle-switch:before {
      transform: translateX(18px);
    }

    &:not(.disabled) {
      .toggle-switch {
        background-color: var(--cue-bg-primary-default);
        border-color: var(--cue-bg-primary-default);

        &:hover {
          background-color: var(--cue-bg-primary-default-hover);
          border-color: var(--cue-bg-primary-default-hover);
        }
      }

      .toggle-switch:before {
        background-color: var(--cue-bg-primary-on-default);
      }
    }
  }

  &.disabled {
    color: var(--cue-content-neutral-disabled);
    cursor: not-allowed;

    .toggle-switch {
      background-color: var(--cue-bg-neutral-disabled);
      border-color: var(--cue-border-neutral-disabled);
    }

    .toggle-switch:before {
      background-color: var(--cue-content-neutral-disabled);
    }
  }
}
</style>
